export async function dataFetch(url) {
  const response = await fetch(url, { credentials: 'include' });
  const eTag = response.headers.get('ETag');
  const data = await response.json();
  return { data, eTag };
}
